module.exports = __webpack_public_path__ + "img/feature-1.10586df7.png";